import EuroIcon from '@mui/icons-material/Euro';
import { Box, Typography } from '@mui/material';
import numeral from 'numeral';

import { DEFAULT_BORDER } from 'src/constants';

interface ThumbnailCardProps {
    label: string;
    amount: number;
}

const ThumbnailCard = ({ label, amount }: ThumbnailCardProps) => {
    return (
        <Box>
            <Box
                sx={{
                    textAlign: 'center',
                    backgroundColor: '#F39E4E',
                    color: '#fff',
                    padding: '10px',
                    borderRadius: '10px 10px 0 0',
                }}
            >
                <Typography sx={{ fontSize: '18px' }}>{label}</Typography>
            </Box>
            <Box
                sx={{
                    ...DEFAULT_BORDER,
                    display: 'flex',
                    justifyContent: 'center',
                    borderTop: 'none',
                    borderRadius: '0 0 10px 10px',
                    padding: '10px',
                }}
            >
                <EuroIcon sx={{ fontSize: '18px', marginRight: '5px' }} />
                <Typography sx={{ marginTop: '-3px', fontSize: '18px' }}>
                    {numeral(`${amount}`).format('0,0.00')}
                </Typography>
            </Box>
        </Box>
    );
};
export default ThumbnailCard;
